import React from "react";
import curve from "../../assets/icons/curvyline.svg";

const FaqTop = () => {
	return (
		<>
			{/* Title and Description */}
			<div className='text-center'>
				<h1 className='lg:text-[72px]/[79px] text-[40px]/[49px] lg:tracking-[-2px] tracking-[-1.72px] font-medium text-[#11112D] mb-4'>
					Frequently Asked <br />
					Questions
				</h1>
			</div>
			<img
				src={curve}
				alt='Curve Decoration'
				className='absolute lg:top-[17%] top-[5%] md:right-0 right-[-25%] w-[150px] md:w-[200px] lg:w-[250px]'
			/>
			<p className='max-w-[656px] w-full mx-auto text-center md:text-xl/[30px] text-xs/[21px] text-[#11112d] font-normal mb-8'>
				Find answers to common questions about SynergyCare Foundation’s mission,
				services, and involvement opportunities.{" "}
			</p>
		</>
	);
};

export default FaqTop;
